<div class="bg-white shadow-md text-2xl w-full rounded-2xl px-8 py-4">
    Thank-you for your regalia order!
</div>